import { render, staticRenderFns } from "./SidebarStudentListItem.vue?vue&type=template&id=5f772cd8&"
import script from "./SidebarStudentListItem.vue?vue&type=script&lang=ts&"
export * from "./SidebarStudentListItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports